import '../css/MessageNotificationIcon.css';

const SignatureNotificationIcon = ({ isVisible }) => {
  if (isVisible) {
    return (
      <span className="glyphicon glyphicon-exclamation-sign pending-signature"></span>
    );
  }
  return null;
};

export default SignatureNotificationIcon;

